/*
 * @Description: 
 * @Author: Liu Yang
 * @Date: 2021-08-23 09:53:24
 * @LastEditTime: 2021-08-23 10:33:22
 * @LastEditors: Liu Yang
 * @FilePath: \earth-vue\src\store\state.js
 */
// import db from '../common/comFun/db'
export default {
  name: ''
}
